<template>
  <div class="main-wrapper">
    <div class="row justify-content-center h-100">
      <div class="col-xl-6 w-30 align-top">
        <div class="row justify-content-center left-side">
          <div class="col-sm-8">
            <div class="card">
              <div class="row">
                <div class="col-lg-12">
                  <div class="text-center auth-logo">
                    <img
                        src="@/assets/images/logo-dark.png"
                        alt
                        height="120"
                        class="logo logo-dark"
                    />
                    <img
                        src="@/assets/images/logo-light.png"
                        alt
                        height="120"
                        class="logo logo-light"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body p-4">

                <LoginWidget @showpasswordparent="password = $event"></LoginWidget>

                <!-- end card-body -->
              </div>
              <!-- end card -->
            </div>



          </div>
          <div class="row bottom">
            <footer class="lp-footer">
              <p><span class="copyright">© {{ new Date().getFullYear() }} LeveragePoint Innovations Inc.</span>
                <span> | </span>
              <a class="gwt-Anchor" style="color:#394BA7;" href="https://www.leveragepoint.com/about-us/security/" target="_blank">Security Policy</a>
              <span> | </span>
              <a class="gwt-Anchor" style="color:#394BA7;" href="https://apps.leveragepoint.com/1/api/Download/Public/App_Global?fileName=LeveragePoint+Privacy+Policy+-+October+2020.pdf" target="_blank">Privacy Policy</a>
              <br>
              <a class="gwt-Anchor" style="color:#394BA7;" href="mailto:techsupport@leveragepoint.com">techsupport@leveragepoint.com</a>
              <span> | </span>
              <a class="gwt-Anchor" style="color:#394BA7;" href="https://support.leveragepoint.com/hc/en-us/categories/360000981732-Product-Announcements" target="_blank">Release Notes</a></p>
            </footer>
            <!-- end lp-footer -->
          </div>
        </div>
      </div>
      <div class="col-xl-6 h-100 w-50">
        <div class="img">
          <img :src="background" alt="Img" />
        </div>
        <div class="img-text h-100 w-100" style="z-index: 9999; position:absolute; bottom: 0;">


          <!--          Start Webinar Div-->
          <div class="row avatar">
            <div class="col-sm-8 webinar">
              <span class="title-lg-1" style="white-space: pre-line">{{ this.title1 }}</span><br><br><br>
              <div class="border-sm-1"></div>
              <span class="title-md-1">{{ this.title2 }}</span><br>
              <span class="sub-title-1">{{ this.subtitle }}</span><br><br>
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <img v-if="thumbnailSrc" :src="thumbnailSrc" class="avatarImage" alt="Img"/>
                </div>
                <div class="col-sm-9">
                  <span class="text-1" style="white-space: pre-line">{{ this.thumbnailtitle }}</span>
                  <span class="sub-text-1">{{ this.thumbnailsubtitle }}</span>
                </div>
              </div>
              <br>
              <span class="buttonMarketing">
              <b-button
                  class="right-side-btnsMarketing"
                  variant="primary"
                  :href="this.buttonlink"
                  target="_blank"
              >
                {{ this.buttontext }}
              </b-button>
              </span>
				<img :src="rightImage" class="rightImage" alt="Img"/>
            </div>

          </div>
          <!--          End Webinar Div-->

        </div>

      </div>
      <!-- end parent col -->
    </div>
    <!-- end parent row -->
  </div>

</template>

<script>
import appConfig from "@/app.config";
import LoginWidget from "@/components/account/login-widget";
import background from './assets/images/LPI-LoginPage-RightSide-SolidBackground.jpg'
import rightImage from './assets/images/collage-tool.png'
import leftImage from './assets/images/CustomerSupportIcon-Andrew-384x383-flipped.png'
import avatar from './assets/images/PeytonAvatarSolid.png'

/**
 * Login component
 */
export default {
  components: {
    LoginWidget,
  },
  data: function () {
    return {
      background,
      rightImage,
      leftImage,
      avatar,
      password: false,
      title1: '',
      title2: '',
      subtitle: '',
      file: null,
      file1: null,
      thumbnailtitle: '',
      thumbnailsubtitle: '',
      buttontext: '',
      buttonlink: '',
      thumbnailSrc: ''
    }
  },
  page: {
    title: "LeveragePoint - Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  async mounted() {
    document.body.classList.add("authentication-bg");
    addEventListener('resize', () => {
      if (window.innerWidth <= 1200) {
        window.drift.hide();
      } else {
        window.drift.show();
      }
    })

    if (window.visualViewport.height <= 500) {
      this.$drift.config({
        enableCampaigns: false,
      })
    }
    else if (window.innerWidth <= 1200 && window.innerWidth >= 500) {
      this.$drift.config({
        enableCampaigns: false,
      })
    } else if (window.innerWidth < 700) {
      window.drift.hide();
    } else {
      this.$drift.config({
        enableCampaigns: true
      })
    }
    const response = await fetch(`${process.env.VUE_APP_ENV_SERVER}/lpi-service/getLoginContent/first`, {
      method: 'GET',
      headers: {'Content-Type': 'application/json'}
    });
    const data = await response.json()
    this.title1=data.titleLarge
    this.title2=data.titleMedium
    this.subtitle=data.subtitle
    this.thumbnailtitle=data.thumbnailTitle
    this.thumbnailsubtitle=data.thumbnailSubtitle
    this.buttontext=data.buttonText
    this.buttonlink=data.buttonHref
    this.thumbnailSrc=data.thumbnailSrc




  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,400;0,700;1,400');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400');

/* Initial Screen Load CSS */
.main-wrapper {
  overflow: hidden;
  font-family: 'Raleway',serif;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
  min-height: 600px;
}

.row {
  flex-wrap: nowrap !important;
}

.left-side {
  display: table-cell;
  height: 100%;
  position: relative;
  margin-bottom: 5%;
}

.auth-logo {
  padding-top: 20px;
  margin-bottom: -5px;
}

.card {
  margin-top: 100px !important;
  background-color: rgba(240, 239, 232, 1) !important;
  border-radius: 25px !important;
  padding-top: 50px;
  padding-bottom: 50px;
  box-shadow: 0 2px 4px rgb(255 255 255 / 0%)!important;
}

.lp-footer {
  position: absolute;
  font-size: 12px;
  text-align: center;
  font-family: 'Open Sans',serif;
  margin-top:20px!important;
}

.row.bottom {
  position: absolute;
  bottom: -5px;
}

.btn.right-side-btnsMarketing.btn-primary {
  background-color: #ec6822;
  border-color: transparent;
  border-radius: 8px;
  width: 180px;
  height: 40px;
  margin-top: 10px;
}

.btn.right-side-btnsMarketing.btn-primary:hover {
  background-color: #0a7c41;
  border-color: transparent;
  border-radius: 8px;
  width: 180px;
  height: 40px;
  margin-top: 10px;
}

.button {
  padding-left: 0 !important;
}

.title-lg-1 {
  padding-left: 0 !important;
  color: rgba(255, 255, 255, 1);
  font-size: 32px;
  font-weight:600;
  line-height: 36px;
  text-align: left;
  top: 10px;
  margin-top:50px !important;
}

.title-md-1 {
  padding-left: 0 !important;
  color: rgba(150, 192, 100, 1);
  font-size: 28px;
  line-height: 26px;
  font-weight: 700;

}

.sub-title-1 {
  padding-left: 0 !important;
  padding-top: 5px;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
}

.text-1 {
  padding-left: 0 !important;
  padding-bottom: 0px;
  color: rgba(255, 255, 255, 1);
  width: 425px !important;
  display: block;
  word-wrap:break-word;
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  font-family: 'Open Sans',serif;
}

.sub-text-1 {
  font-size: 16px;
  font-weight: 400;
  font-family: 'Open Sans',serif;
  color: rgba(255, 255, 255, 1);
}

.border-sm-1 {
  width: 30px !important;
  height: 2px;
  box-sizing: border-box;
  object-fit: cover;
  border-color: transparent;
  background-color: rgba(236, 105, 37, 1);
}

.rightImage {
  position: relative;
  margin-bottom: 0px!important;
  top: 100px;
  width: 70% !important;
  left: 20px;
}

.img img {
  width: 100%; height: 100%; object-fit: cover;
}

.col-sm-8.marketing {
    text-align: left;
    margin-top: -50px!important;
    left: 20px;
	width:80%;
}

.col-sm-8.customer-support {
  text-align: center;
  margin-top:40px;
  width:100%;
  top:-50px;
}

.col-sm-8.webinar {
  text-align: left;
  margin-top: -60px!important;
  left: 20px;
  width:100%;
}

.col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
    margin-bottom: 15px;
	margin-top: -10px!important;
}

.col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
    margin-left: -50px;
    margin-bottom: 10px;
}

.row.align-items-center {
  bottom: 20px!important;
}

.row.wp, .row.avatar {
  margin: 100px 30px 30px 30px;
  top: 0
}

.border-sm-1 {
  margin-bottom: 25px;
}

.row.align-items-center.cs {
  margin: 30px 30px 5px 30px;
  bottom:150px;
  position: absolute;
}

.align-items-center {
    align-items: center !important;
    margin-bottom: -20px;
}

.hidden-br {
  display: none !important;
}

.copyright {
  display: inline-block;
}

.rightImage {
  position: absolute;
  left: -25px;
  top: 400px;
}

@media screen and (max-height: 450px) {
  html {
    overflow-y: scroll;
  }
}

@media screen and (max-height: 768px) {
  .main-wrapper {
    margin: 0 auto;
  }

  .card {
    padding-top: 20px !important;
    margin-top: 50px !important;
  }

  .auth-logo img {
    height: 80px;
  }
}

  /* Media Queries for Width */
@media screen and (max-width: 499px) {
  .main-wrapper {
    font-size: 12px;
  }

  .card {
    margin-top: 50px !important;
  }

  .auth-logo img {
    height: 80px;
  }
}

@media screen and (max-width: 1200px) {
  .col-xl-6.h-100.w-50 {
    display: none !important;
    overflow: scroll;
  }

  .row.bottom {
    bottom: 2px;
  }
}

@media screen and (min-width: 1000px) {

	.col-sm-8.webinar {
    text-align: left;
    margin-top: 0px !important;
    width: 100%;
  }

.title-lg-1 {
    padding-left: 0!important;
    font-size: 38px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    top: 50px;
}


.row.wp, .row.avatar {
    margin: 80px 30px 30px 30px;
    top: 0px;
  }

  .border-sm-1 {
    margin-bottom: 15px;
	margin-top: -20px;
  }

	.text-1 {
    line-height: 32px;
    font-size: 18px;
    width: 120%!important;
}

.row.align-items-center.cs {
  margin: 30px 30px 5px 30px;
  bottom:150px;
  position: absolute;
}
  .title-md-1 {
    font-size: 26px;
    line-height: 38px;
  }

  .sub-title-1 {
    line-height: 20px;
    font-size: 18px;
  }

  .avatarImage {
    width: 60%
  }

  .row.bottom {
    font-size: 12px;
    height: 60px;
    margin-bottom: 5px;
	}}

</style>
